const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/invites/auto-accept.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { ensureNamespaceLoaded } from '@/lib/translations/i18nloader';
import { inviteAutoAcceptIntent } from '@/lib/utils/invites/autoAcceptIntent';
const searchSchema = z.object({
  inviteId: z.number().optional()
});
export const Route = createFileRoute('/(app)/invites/auto-accept')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(searchSchema),
  // PickMethodCard (rendered when the invited org needs a sign-in method chosen) reads the
  // 'login' namespace, so load it here too.
  beforeLoad: () => ensureNamespaceLoaded('login'),
  // The invite-email flow carries a one-time token via intent; the in-app invites list passes an
  // authenticated inviteId in search instead.
  loader: () => ({
    token: inviteAutoAcceptIntent.take()
  })
});